<template>
    <div class="owl-carrusel">
        <carousel
            :items="1"
            :nav="false"
            :dots="false"
            :autoplay="true"
            :loop="true"
        >
            <img
                :src="`https://photo-public.s3.amazonaws.com/suf/sliders/home/sitio-unificado-foto-${idx}.jpg`"
                v-for="idx in 24"
                :key="idx"
            />
        </carousel>
    </div>
</template>

<script>
import carousel from "vue-owl-carousel";

export default {
    components: { carousel },
};
</script>

<style></style>
